exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "h1{font-size:50px}h1 small{font-size:25px}h3{font-size:30px}.glitch{margin-bottom:20px;padding:20px;font-size:40px}body{align-items:center;background:#47484b;color:#62b486;font-family:courier;box-sizing:border-box;text-align:center}table{margin:auto;padding:10px;border-collapse:collapse}table td,table th{border:1px dotted #fff;padding:20px}table th{color:#fff;font-weight:700}pre{margin-bottom:40px}code{padding:10px;line-height:40px;border-radius:5px;background:#3d3d3d;color:#f3f3fe}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-18311b62","scoped":false,"hasInlineConfig":false}!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./docs/App.vue
// module id = 8
// module chunks = 0